import axios from 'axios';
import { getToken } from '../utils/cookieUtils';


const serverUrl = process.env.REACT_APP_SERVER_URL ?? 'https://mintworxs.org';
// TODO: add this for test env file
console.log('Current API URL:', process.env.REACT_APP_SERVER_URL);
console.log('Env : ', process.env.REACT_APP_ENV);

const axiosClient = axios.create({
  baseURL: serverUrl,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosClient.interceptors.request.use(
  (config) => {
    const authData = getToken();
    if (authData && authData?.token?.access) {
      config.headers.Authorization = `${authData?.token?.access}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosClient.interceptors.response.use(
  (response) => {
    if (response.data?.success === 1) {
      return response.data;
    } else {
      console.error(response.data);
      return Promise.reject({
        statusCode: response.data?.statusCode || 500,
        message: response.data?.message || 'Unknown error occurred',
        errorDetails: response.data?.errorDetails || [],
      });
    }
  },
  (error) => {
    console.error(error.response);
    const errorResponse = {
      statusCode: error.response?.status || 500,
      message: error.message || 'Network error occurred',
      errorDetails: error.response?.data?.errorDetails || [],
    };
    return Promise.reject(errorResponse);
  },
);

export default axiosClient;
